import { render, staticRenderFns } from "./AgTableImageCell.vue?vue&type=template&id=2cc4f620&scoped=true&"
import script from "./AgTableImageCell.vue?vue&type=script&lang=js&"
export * from "./AgTableImageCell.vue?vue&type=script&lang=js&"
import style0 from "./AgTableImageCell.vue?vue&type=style&index=0&id=2cc4f620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc4f620",
  null
  
)

export default component.exports